import type { IPopularMixParlay } from '@/interface/IPopularMixParlay';
import type { RogueModelsResponsesPopularMixParlayResponse } from '@/interface/rogue';

export function formatMpRecommendation(response: RogueModelsResponsesPopularMixParlayResponse): IPopularMixParlay[] {
    return (response.popularMixParlayBets ?? []).map(mp => ({
        key: (mp.popularMixParlaySubBets ?? []).map(sb => `${sb.eventId}-${sb.oddsId}-${sb.option}`).join('-'),
        ticketKeys: (mp.popularMixParlaySubBets ?? []).map(sb => ({
            eventId: sb.eventId ?? 0,
            oddsId: sb.oddsId ?? 0,
            option: sb.option ?? '',
        })),
    }));
}
